export const fegli = {
  17: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  18: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  19: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  20: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  21: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  22: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  23: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  24: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  25: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  26: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  27: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  28: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  29: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  30: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  31: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  32: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  33: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  34: {
    bracket: 1,
    optionA: 0.43,
    optionB: 0.043,
    optionC: 0.43,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  35: {
    bracket: 2,
    optionA: 0.65,
    optionB: 0.043,
    optionC: 0.52,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  36: {
    bracket: 2,
    optionA: 0.65,
    optionB: 0.043,
    optionC: 0.52,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  37: {
    bracket: 2,
    optionA: 0.65,
    optionB: 0.043,
    optionC: 0.52,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  38: {
    bracket: 2,
    optionA: 0.65,
    optionB: 0.043,
    optionC: 0.52,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  39: {
    bracket: 2,
    optionA: 0.65,
    optionB: 0.043,
    optionC: 0.52,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  40: {
    bracket: 3,
    optionA: 0.65,
    optionB: 0.065,
    optionC: 0.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  41: {
    bracket: 3,
    optionA: 0.65,
    optionB: 0.065,
    optionC: 0.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  42: {
    bracket: 3,
    optionA: 0.65,
    optionB: 0.065,
    optionC: 0.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  43: {
    bracket: 3,
    optionA: 0.65,
    optionB: 0.065,
    optionC: 0.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  44: {
    bracket: 3,
    optionA: 0.65,
    optionB: 0.065,
    optionC: 0.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  45: {
    bracket: 4,
    optionA: 1.3,
    optionB: 0.13,
    optionC: 1.15,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  46: {
    bracket: 4,
    optionA: 1.3,
    optionB: 0.13,
    optionC: 1.15,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  47: {
    bracket: 4,
    optionA: 1.3,
    optionB: 0.13,
    optionC: 1.15,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  48: {
    bracket: 4,
    optionA: 1.3,
    optionB: 0.13,
    optionC: 1.15,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  49: {
    bracket: 4,
    optionA: 1.3,
    optionB: 0.13,
    optionC: 1.15,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  50: {
    bracket: 5,
    optionA: 2.17,
    optionB: 0.217,
    optionC: 1.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  51: {
    bracket: 5,
    optionA: 2.17,
    optionB: 0.217,
    optionC: 1.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  52: {
    bracket: 5,
    optionA: 2.17,
    optionB: 0.217,
    optionC: 1.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  53: {
    bracket: 5,
    optionA: 2.17,
    optionB: 0.217,
    optionC: 1.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  54: {
    bracket: 5,
    optionA: 2.17,
    optionB: 0.217,
    optionC: 1.8,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  55: {
    bracket: 6,
    optionA: 3.9,
    optionB: 0.39,
    optionC: 2.88,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  56: {
    bracket: 6,
    optionA: 3.9,
    optionB: 0.39,
    optionC: 2.88,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  57: {
    bracket: 6,
    optionA: 3.9,
    optionB: 0.39,
    optionC: 2.88,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  58: {
    bracket: 6,
    optionA: 3.9,
    optionB: 0.39,
    optionC: 2.88,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  59: {
    bracket: 6,
    optionA: 3.9,
    optionB: 0.39,
    optionC: 2.88,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  60: {
    bracket: 7,
    optionA: 13,
    optionB: 0.867,
    optionC: 5.27,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  61: {
    bracket: 7,
    optionA: 13,
    optionB: 0.867,
    optionC: 5.27,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  62: {
    bracket: 7,
    optionA: 13,
    optionB: 0.867,
    optionC: 5.27,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  63: {
    bracket: 7,
    optionA: 13,
    optionB: 0.867,
    optionC: 5.27,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  64: {
    bracket: 7,
    optionA: 13,
    optionB: 0.867,
    optionC: 5.27,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0.3467,
    reduction50: 1.0967,
    noReduction: 2.5967,
  },
  65: {
    bracket: 8,
    optionA: 13,
    optionB: 1.04,
    optionC: 6.13,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  66: {
    bracket: 8,
    optionA: 13,
    optionB: 1.04,
    optionC: 6.13,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  67: {
    bracket: 8,
    optionA: 13,
    optionB: 1.04,
    optionC: 6.13,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  68: {
    bracket: 8,
    optionA: 13,
    optionB: 1.04,
    optionC: 6.13,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  69: {
    bracket: 8,
    optionA: 13,
    optionB: 1.04,
    optionC: 6.13,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  70: {
    bracket: 9,
    optionA: 13,
    optionB: 1.863,
    optionC: 8.3,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  71: {
    bracket: 9,
    optionA: 13,
    optionB: 1.863,
    optionC: 8.3,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  72: {
    bracket: 9,
    optionA: 13,
    optionB: 1.863,
    optionC: 8.3,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  73: {
    bracket: 9,
    optionA: 13,
    optionB: 1.863,
    optionC: 8.3,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  74: {
    bracket: 9,
    optionA: 13,
    optionB: 1.863,
    optionC: 8.3,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  75: {
    bracket: 10,
    optionA: 13,
    optionB: 3.9,
    optionC: 12.48,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  76: {
    bracket: 10,
    optionA: 13,
    optionB: 3.9,
    optionC: 12.48,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  77: {
    bracket: 10,
    optionA: 13,
    optionB: 3.9,
    optionC: 12.48,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  78: {
    bracket: 10,
    optionA: 13,
    optionB: 3.9,
    optionC: 12.48,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  79: {
    bracket: 10,
    optionA: 13,
    optionB: 3.9,
    optionC: 12.48,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  80: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  81: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  82: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  83: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  84: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  85: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  86: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  87: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  88: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  89: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  90: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  91: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  92: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  93: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  94: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  95: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  96: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  97: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  98: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  99: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  100: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  101: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  102: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
  103: {
    bracket: 11,
    optionA: 13,
    optionB: 6.24,
    optionC: 16.9,
    workingNonPostal: 0.3467,
    workingPostal: 0,
    reduction75: 0,
    reduction50: 0.75,
    noReduction: 2.25,
  },
}
